export default "__VITE_ASSET__89336afa__"